export default {
  SOLICITADO: 1,
  CANCELADO: 2,
  APROVADO: 3
};
